/**
 * HowItWorks — replaces the design's Founders section.
 * Carries forward the "How We Protect Your Privacy" content from the
 * legacy LandingPage modal, rendered in the editorial 2-up grid the
 * design uses for Founders. Same structural beats: per-pillar number,
 * heading, body, supporting bullets.
 */
import { ArrowRight } from "lucide-react";

const PILLARS = [
  {
    num: "01 / Authentication",
    title: "Hash-Based, Anonymous by Default",
    body: "Your email becomes a SHA-256 hash before it ever touches our servers. We never store your real address. Even our database can't reverse it — and that's the point.",
    bullets: [
      "Your email → SHA-256 → Anonymous ID",
      "Cryptographically impossible to reverse",
      "We never see your actual address",
    ],
  },
  {
    num: "02 / Storage",
    title: "Zero Conversation History",
    body: "Your prompts aren't saved, indexed, or used to train models. There is no chat history on our servers. Inference happens, the response returns, and the request is gone.",
    bullets: [
      "No prompt logging, no training data",
      "No chat history on our servers",
      "Inference runs on stateless nodes",
    ],
  },
];

export default function HowItWorks() {
  return (
    <section id="how">
      <div className="container">
        <div className="section-head">
          <div className="label reveal">/ 04 — How it works</div>
          <div>
            <h2 className="reveal d1">Two pillars. Both enforced by the architecture.</h2>
          </div>
        </div>

        <div className="founders-grid reveal d2">
          {PILLARS.map((p) => (
            <div key={p.num} className="founder">
              <div className="portrait">{p.num.split(" / ")[0]}</div>
              <div>
                <div className="who">{p.num}</div>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
                <ul>
                  {p.bullets.map((b) => (
                    <li key={b}>
                      <ArrowRight size={11} strokeWidth={1.5} style={{ color: "var(--accent)", marginRight: 6, verticalAlign: "-1px" }} />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
